import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  img: {
    margin: '0 auto',
    display: 'block',
    maxWidth: '100%',
  },
  other: {
    backgroundColor: theme.palette.opaque.white,
  },
  spotlightWrapper: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
    },
  },
  articlesWrapper: {
    '&>div': {
      [theme.breakpoints.down('sm')]: {
        paddingBottom: theme.spacing(1),
      },
    },
  },
  sliderContainer: {
    '&>div': { // partner logos root
      paddingTop: 0,
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        paddingTop: 0,
        paddingBottom: theme.spacing(4),
      },
    },
    '&>div>div>div:nth-child(1)': { // slider headline
      paddingBottom: 0,
      paddingTop: theme.spacing(4),
    },
    '&>div>div>div:nth-child(2)>div': { // keen slider, card parent
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down('xs')]: {
      },
      [theme.breakpoints.up('sm')]: {
        overflow: 'hidden !important',
      },
    },
  },
  leaderboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:last-child)': {
      marginBottom: '5.125rem',
    },
  },
}))

export default useStyles
